export default __webpack_public_path__ + "static/Laser_eyes-06ea7f90a19d0dc7fa6f5a01b2eecaff.png";